import UrlHelper from '@/services/UrlHelper';

const previewTypePathRegex: RegExp = /mannequin-(left|right|center)/;
const previewRotationRegex: RegExp = /&rotation=\d/;

const replacePreviewUrlWithCorrectRotation = (url: string, index: number): string => {
  const colIndex = index % 3;
  const newPreviewTypePath = UrlHelper.OUTFIT_PREVIEW_TYPES[colIndex];
  const newRotation = `&rotation=${UrlHelper.OUTFIT_PREVIEW_ROTATIONS[colIndex]}`;

  return (
    url
      // Legacy mannequin renders are no longer supported
      .replace('style=1', 'style=5')
      .replace(previewTypePathRegex, newPreviewTypePath)
      .replace(previewRotationRegex, newRotation)
  );
};

export default {
  replacePreviewUrlWithCorrectRotation,
};
